// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w13O","questions":"styles_questions__1Rltt","footer":"styles_footer__1WQAV"};